module.exports = __webpack_public_path__ + "static/img/hero.60cb649.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hero.svg
// module id = z8hO
// module chunks = 12